import { render } from "./HeroiconsOutlineScale.vue?vue&type=template&id=318cc8b3"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineScale.vue"]])

export default __exports__